module.exports = __webpack_public_path__ + "static/img/my-pay.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/my-pay.png
// module id = 576
// module chunks = 0